module.exports = __webpack_public_path__ + "media/images/prizes__prizeFg--4-29f5942d58fe6a76fc3d79347ccfd2c2.png";